import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { DirectivesModule } from '../../../components/directives.module';
import { ListComponent } from './list.component';
import { ListActionCellComponent } from './list-action-cell/list-action-cell.component';
import { ListCompleteActionCellComponent } from './list-complete-action-cell/list-complete-action-cell.component';

const ROUTES: Routes = [
  {
    path: '',
    component: ListComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    RouterModule.forChild(ROUTES),
    AgGridAngular,
  ],
  declarations: [ListComponent, ListActionCellComponent, ListCompleteActionCellComponent],
  exports: [ListComponent],
})
export class ListModule {
}
